<div class="about-us">
    <div class="about-us__block">
        <div class="about-us__text">
            {{"about-us.about-us" | translate}}
        </div>
    </div>
    <div class="about-us__block">
        <app-bordered-product [imageSrc]="img"></app-bordered-product>
    </div>
</div>